<template>
  <div>
    <transition name="slide-fade">
      <v-alert
        v-if="showErrorAlert"
        class="ecdt-alert"
        :type="alertType"
        elevation="5"
        dismissible
      >{{errorAlertText}}</v-alert>
    </transition>

    <v-container @keydown.enter="$event.preventDefault()" @submit="calcularClickHandler()" class="pl-7 pr-7">
      <v-form ref="form" v-model="formValid" lazy-validation id="userRegisterForm">
        <v-row>
          <v-col>
            <h3>Preencha os campos abaixo para calcular o quanto quiser seu funil</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="form-label">Nome*</div>

            <v-text-field
              outlined
              v-model="inputs.inputName"
              placeholder="Digite aqui sua resposta"
              required
            ></v-text-field>

            <div class="form-label">Email*</div>
            <v-text-field
              outlined
              v-model="inputs.inputEmail"
              placeholder="Digite aqui sua resposta"
              required
            ></v-text-field>

            <div class="form-label">Telefone*</div>
            <v-text-field
              outlined
              maxlength="15"
              v-model="inputs.inputTelephone"
              placeholder="Digite aqui sua resposta"
              required
            ></v-text-field>

            <div class="form-label">Empresa*</div>
            <v-text-field
              outlined
              v-model="inputs.inputCompanyName"
              placeholder="Digite aqui sua resposta"
              required
            ></v-text-field>

            <div class="form-label">Ramo de Atividade*</div>
            <v-select
              outlined
              v-model="inputs.inputRamo"
              :items="itemsRamo"
              placeholder="Selecione"
              required
            ></v-select>

            <div class="form-label">Cargo*</div>
            <v-select
              outlined
              v-model="inputs.inputCargo"
              :items="itemsCargo"
              placeholder="Selecione"
              required
            ></v-select>

            <div class="form-label">Quantos vendedores tem na sua empresa no total?*</div>
            <v-select
              outlined
              v-model="inputs.inputQtdVend"
              :items="itemsQtdVenda"
              placeholder="Selecione"
              required
            ></v-select>

            <div class="form-label">Quantos funcionários têm na sua empresa?*</div>
            <v-select
              outlined
              v-model="inputs.inputQtdFunc"
              :items="itemsQtdFunc"
              placeholder="Selecione"
              required
            ></v-select>

            <div class="form-label">Qual CRM utiliza?*</div>
            <v-select
              outlined
              v-model="inputs.inputCrm"
              :items="itemsCrm"
              placeholder="Selecione"
              required
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="d-flex justify-end">
              <v-btn
                color="#fe5c82"
                x-large
                type="submit"
                class="mr-4 wrapper-next-button button-calcular"
              >CALCULAR</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import RdStationService from '@/services/RdStationService'

export default {
  components: {},
  directives: { mask },
  data: function() {
    return {
      TOKEN_ECDT: 'd67b9b3726f13538b2335c5c36aa4874',
      TOKEN_AGENDOR: '497f471ef98c83d148af5231eecbab56',
      showErrorAlert: false,
      errorAlertText: '',
      alertType: '',

      inputs: {
        inputName: '',
        inputEmail: '',
        inputCompanyName: '',
        inputRamo: '',
        inputCargo: '',
        inputQtdVend: '',
        inputQtdFunc: '',
        inputTelephone: '',
        inputCrm: '',
      },
      formValid: false,

      itemsCargo: [
        { text: 'Empresário/CEO', value: 'Empresário/CEO' },
        { text: 'Diretor/Gerente de Vendas ou Marketing', value: 'Diretor/Gerente de Vendas ou Marketing' },
        { text: 'Diretor/Gerente de Outra Área', value: 'Diretor/Gerente de Outra Área' },
        { text: 'Analista, Vendedor ou Pré-Venda', value: 'Analista, Vendedor ou Pré-Venda' },
        { text: 'Autônomo/Representante', value: 'Autônomo/Representante' },
        { text: 'Outros', value: 'Outros' },
      ],
      itemsRamo: [
        {text: 'Autônomo', value: 'Autônomo'},
        {text: 'Agência de Comunicação / Digital', value: 'Agência de Comunicação / Digital'},
        {text: 'Agência de turismo / viagens', value: 'Agência de turismo / viagens'},
        {text: 'Automação comercial / residencial / industrial', value: 'Automação comercial / residencial / industrial'},
        {text: 'Beleza', value: 'Beleza'},
        {text: 'Concessionária de veículos', value: 'Concessionária de veículos'},
        {text: 'Consultoria de TI / RH / Marketing e outros', value: 'Consultoria de TI / RH / Marketing e outros'},
        {text: 'Contabilidade', value: 'Contabilidade'},
        {text: 'Corretora de Seguros', value: 'Corretora de Seguros'},
        {text: 'Distribuidora', value: 'Distribuidora'},
        {text: 'Ecommerce', value: 'Ecommerce'},
        {text: 'Editora', value: 'Editora'},
        {text: 'Educação', value: 'Educação'},
        {text: 'Escritório de advocacia', value: 'Escritório de advocacia'},
        {text: 'Eventos', value: 'Eventos'},
        {text: 'Imobiliária', value: 'Imobiliária'},
        {text: 'Importação / Exportação', value: 'Importação / Exportação'},
        {text: 'Indústria', value: 'Indústria'},
        {text: 'Lojista / Loja física', value: 'Lojista / Loja física'},
        {text: 'Prestador de serviços', value: 'Prestador de serviços'},
        {text: 'Representante comercial', value: 'Representante comercial'},
        {text: 'Saúde', value: 'Saúde'},
        {text: 'Software', value: 'Software'},
        {text: 'Tecnologia', value: 'Tecnologia'},
        {text: 'Telecomunicações', value: 'Telecomunicações'},
        {text: 'Outros', value: 'Outros'},
      ],
      itemsQtdVenda: [
        {text: '1 pessoa', value: '1 pessoa'},
        {text: '2 pessoas', value: '2 pessoas'},
        {text: '3 pessoas', value: '3 pessoas'},
        {text: '4 pessoas', value: '4 pessoas'},
        {text: '5 pessoas', value: '5 pessoas'},
        {text: '6 pessoas', value: '6 pessoas'},
        {text: '7 pessoas', value: '7 pessoas'},
        {text: '8 pessoas', value: '8 pessoas'},
        {text: '9 pessoas', value: '9 pessoas'},
        {text: '10 pessoas', value: '10 pessoas'},
        {text: '11 a 20 pessoas', value: '11 a 20 pessoas'},
        {text: '21 a 50 pessoas', value: '21 a 50 pessoas'},
        {text: '51 a 100 pessoas', value: '51 a 100 pessoas'},
        {text: 'mais que 101 pessoas', value: 'mais que 101 pessoas'},
      ],
      itemsQtdFunc: [
        {text: '1-4', value: '1-4'},
        {text: '5-10', value: '5-10'},
        {text: '11-20', value: '11-20'},
        {text: '21-50', value: '21-50'},
        {text: '51-200', value: '51-200'},
        {text: '201-500', value: '201-500'},
        {text: 'Mais que 500', value: 'Mais que 500'},
      ],
      itemsCrm: [
        { text: 'Uso CRM', value: 'Uso CRM' },
        { text: 'Uso Excel como CRM', value: 'Uso Excel como CRM' },
        { text: 'Não uso CRM', value: 'Não uso CRM' },
      ],
      showAlertTimeoutFunction: null
    }
  },
  props: {
    test: {
      type: String,
      required: false,
      default: ''
    }
  },
  watch: {
    "inputs.inputTelephone": function(data) {
      this.inputs.inputTelephone = data.toString().replace(/\D/g, '').substring(0,11).replace(/(\d{2})(\d{1,5})(\d{0,4})/g, "($1) $2 $3");
    },
  },
  methods: {
    emitInputChange(fieldName, value) {
      this.$emit('input-change', fieldName, value)
    },
    calcularClickHandler() {
      event.preventDefault();
      // Write form info in the dataLayer so Tag Manager can access it
      window.dataLayer.push({
        'ecdtFormInfo': [
          { id: 'name', value: this.inputs.inputName, classList: { value: 'name' } },
          { id: 'email', value: this.inputs.inputEmail, classList: { value: 'email' } },
          { id: 'phone', value: this.inputs.inputTelephone, classList: { value: 'phone' } },
          { id: 'company', value: this.inputs.inputCompanyName, classList: { value: 'company' } },
          { id: 'custom_fields_177499', value: this.inputs.inputCargo, classList: { value: 'cf_cargo_lista' } },
          { id: 'custom_fields_353172', value: this.inputs.inputQtdFunc, classList: { value: 'cf_quantidade_de_funcionarios' } },
          { id: 'custom_fields_1509003', value: this.inputs.inputCrm, classList: { value: 'cf_qual_crm_utilizam_simplificado' } },
        ]
      });
      const formValid = this.isFormValid()
      if (formValid) {
        // const leadEcdt = {
        //   nome: this.inputs.inputName,
        //   email: this.inputs.inputEmail,
        //   // empresa: this.inputs.inputCompanyName,
        //   Cargo: this.inputs.inputCargo,
        //   "Ramo de Atividade": this.inputs.inputRamo,
        //   "Quantos vendedores tem na sua empresa": this.inputs.inputQtdVend,
        //   "Quantidade de Funcionários": this.inputs.inputQtdFunc,
        //   "Qual CRM utilizam (simplificado)": this.inputs.inputCrm,
        //   identificador: 'simulador-leads-agendor-ecdt',
        //   traffic_source: this.readCookie('__trf.src'),
        //   client_tracking_id: this.readCookie('rdtrk'),
        // }
        const leadEcdt = {
          name: this.inputs.inputName,
          email: this.inputs.inputEmail,
          personal_phone: this.inputs.inputTelephone.replace(/\D/g, ''),
          company: this.inputs.inputCompanyName,
          job_title: this.inputs.inputCargo,
          "Ramo de Atividade": this.inputs.inputRamo,
          "Quantos vendedores tem na sua empresa": this.inputs.inputQtdVend,
          cf_quantidade_de_funcionarios: this.inputs.inputQtdFunc,
          cf_qual_crm_utilizam_simplificado: this.inputs.inputCrm,
          identificador: 'simulador-leads-agendor-ecdt',
          // traffic_source: this.readCookie('__trf.src'),
          // client_tracking_id: this.readCookie('rdtrk'),
        }

        // If there are UTM params in the URL, fill the traffic params with it, otherwise just use cookie data
        if (this.$route.query.utm_source && this.$route.query.utm_medium && this.$route.query.utm_campaign) {
          leadEcdt['trfsrc'] = this.$route.query.utm_source;
          leadEcdt['traffic_medium'] = this.$route.query.utm_medium;
          leadEcdt['traffic_campaign'] = this.$route.query.utm_campaign;
        } else {
          leadEcdt['trfsrc'] = this.readCookie('__trf.src');
          leadEcdt['rdtrk'] = this.readCookie('rdtrk');
        }

        const leadAgendor = {
          name: this.inputs.inputName,
          email: this.inputs.inputEmail,
          ramo_atividade: this.inputs.inputRamo,
          persona: this.inputs.inputCargo,
          tamanho_empresa: this.inputs.inputQtdVend,
          traffic_source: this.readCookie('__trf.src'),
          client_tracking_id: this.readCookie('rdtrk'), 
          identificador: 'simulador-leads-agendor-ecdt',
          // campos novos do RD
          job_title: this.inputs.inputCargo,
          cf_quantidade_de_funcionarios: this.inputs.inputQtdFunc,
          cf_qual_crm_utilizam_simplificado: this.inputs.inputCrm,
        }

        this.enviaLeadRd(leadEcdt, leadAgendor)
        this.$emit('leadSent', leadEcdt)
      } else {
        this.warnInvalidForm()
      }
    },
    readCookie(cookieName) {
      let fullCookieName = cookieName + "=";
      let arrCookies = document.cookie.split(";");
      for(let i = 0; i < arrCookies.length; i++) {
        let cookie = arrCookies[i];
        while (cookie.charAt(0) == ' ') {
          cookie=cookie.substring(1,cookie.length);
        }
        if (cookie.indexOf(fullCookieName) == 0) {
          return cookie.substring(fullCookieName.length, cookie.length);
        }
      }
      return;
    },
    enviaLeadRd(leadEcdt, leadAgendor) {
      RdStationService.createLead(leadEcdt);
      // RdStationService.addLead(leadEcdt, this.TOKEN_ECDT)
      // RdStationService.addLead(leadAgendor, this.TOKEN_AGENDOR)
    },
    isFormValid() {
      for (var input in this.inputs) {
        if (Object.prototype.hasOwnProperty.call(this.inputs, input)) {
          if (!this.inputs[input]) {
            return false
          }
        }
      }

      return true
    },
    warnInvalidForm() {
      clearTimeout(this.showAlertTimeoutFunction)
      this.showErrorAlert = true
      this.errorAlertText = 'Preencha todos os campos obrigatórios'
      this.alertType = 'error'

      this.showAlertTimeoutFunction = setTimeout(() => {
        this.showErrorAlert = false
      }, 4000)
    },
    alertSuccessForm() {
      clearTimeout(this.showAlertTimeoutFunction)
      this.showErrorAlert = true
      this.errorAlertText = 'Tudo certo!'
      this.alertType = 'success'

      this.showAlertTimeoutFunction = setTimeout(() => {
        this.showErrorAlert = false
      }, 2500)
    }
  }
}
</script>

<style scoped>
.form-label {
  font-size: 14px;
  font-weight: bold;
  color: #3300cc;
  margin-bottom: 0;
}
.button-calcular {
  border-radius: 0;
  color: white;
}

.ecdt-alert {
  position: sticky;
  top: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>